export interface Leistung {
  id: string;
  title: string;
  shortDesc: string;
  fullDesc: string;
  icon: string;
  image: string;
  imageAlt: string;
  subLeistungen: string[];
  vorteile: { icon: string; title: string; text: string }[];
}

export const leistungen: Leistung[] = [
  {
    id: 'sanierung',
    title: 'Sanierung & Renovierung',
    shortDesc: 'Vollständige Gebäudesanierung, energetische Modernisierung und Komplettrenovierung.',
    fullDesc:
      'Ob Altbausanierung, energetische Modernisierung oder vollständige Komplettrenovierung – wir bringen Ihre Immobilie auf den neuesten Stand. Unser erfahrenes Team plant und realisiert jede Sanierungsmaßnahme termingerecht, sauber und zum Festpreis. Von der Einzelraumrenovierung bis zur Kernsanierung eines Mehrfamilienhauses übernehmen wir alle Gewerke aus einer Hand.',
    icon: 'ri-hammer-line',
    image:
      'https://public.readdy.ai/ai/img_res/4cea54ed6f5fb4e718542c8a0d86a549.jpg',
    imageAlt: 'Professionelle Sanierung & Renovierung',
    subLeistungen: [
      'Kernsanierung Wohnungen & Häuser',
      'Energetische Modernisierung',
      'Bad- & Küchensanierung',
      'Fenster- & Türenerneuerung',
      'Heizungsmodernisierung',
      'Elektro- & Sanitärinstallation',
      'Treppe & Treppenhaus Renovierung',
      'Schadstoffsanierung (Schimmel, Asbest)',
    ],
    vorteile: [
      { icon: 'ri-price-tag-3-line', title: 'Festpreisgarantie', text: 'Keine versteckten Kosten – Ihr Angebot gilt.' },
      { icon: 'ri-calendar-check-line', title: 'Termingarantie', text: 'Wir halten vereinbarte Fertigstellungstermine ein.' },
      { icon: 'ri-shield-check-line', title: '5 Jahre Gewährleistung', text: 'Auf alle Sanierungsleistungen geben wir Ihnen volle Sicherheit.' },
      { icon: 'ri-team-line', title: 'Alles aus einer Hand', text: 'Alle Gewerke koordinieren wir für Sie – ein Ansprechpartner.' },
    ],
  },
  {
    id: 'trockenbau',
    title: 'Trockenbau',
    shortDesc: 'Präziser Innenausbau mit Gipskarton, Systemdecken und Trennwänden.',
    fullDesc:
      'Trockenbau ist die schnelle, saubere und flexible Lösung für den modernen Innenausbau. Wir errichten maßgenaue Trennwände, gestalten abgehängte Decken und verkleiden Dachschrägen – für Wohn-, Büro- und Gewerbeflächen jeder Größe. Mit hochwertigen Materialien von Knauf und Rigips erzielen wir perfekte Oberflächen, die sofort gestrichen oder tapeziert werden können.',
    icon: 'ri-layout-3-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20drywall%20interior%20construction%20finished%20modern%20office%20space%20bright%20suspended%20ceiling%20gypsum%20board%20trennwand%20clean%20white%20minimal%20architecture%20germany%20precise%20installation%20sharp%20photo&width=900&height=650&seq=lst-trock-001&orientation=landscape',
    imageAlt: 'Professioneller Trockenbau',
    subLeistungen: [
      'Metallständerwände & Trennwände',
      'Abgehängte Systemdecken',
      'Dachschrägenbekleidung',
      'Schallschutzwände & Akustikelemente',
      'Brandschutzverkleidungen (F30/F90)',
      'Vorsatzschalen & Nischen',
      'Unterkonstruktionen für Fliesen',
      'Spachtelung & Oberflächenbehandlung',
    ],
    vorteile: [
      { icon: 'ri-speed-line', title: 'Schnelle Ausführung', text: 'Trotz hoher Qualität arbeiten wir effizient und termingerecht.' },
      { icon: 'ri-sound-module-line', title: 'Schallschutz', text: 'Optimale Akustiklösungen für ruhige Wohn- und Arbeitsräume.' },
      { icon: 'ri-fire-line', title: 'Brandschutz', text: 'Zertifizierte Brandschutzlösungen bis F90 nach DIN-Norm.' },
      { icon: 'ri-tools-line', title: 'Markenmaterialien', text: 'Ausschließlich geprüfte Materialien von Knauf und Rigips.' },
    ],
  },
  {
    id: 'fassade',
    title: 'Fassade & Außenwände',
    shortDesc: 'Fassadensanierung, WDVS-Systeme und Außenputz für optimale Dämmung und Optik.',
    fullDesc:
      'Die Fassade ist das Gesicht Ihrer Immobilie – und gleichzeitig der wichtigste Schutz vor Witterung und Wärmeverlust. Wir sanieren, dämmen und gestalten Fassaden nach höchsten handwerklichen Standards. Ob Wärmedämmverbundsystem (WDVS), Klinkerverblendung, Sichtbeton oder Strukturputz – wir finden für jedes Gebäude die optimale Lösung und steigern damit Wert und Energieeffizienz nachhaltig.',
    icon: 'ri-home-2-line',
    image:
      'https://readdy.ai/api/search-image?query=freshly%20renovated%20modern%20building%20facade%20exterior%20thermal%20insulation%20WDVS%20system%20white%20smooth%20render%20plaster%20germany%20residential%20urban%20architecture%20professional%20sharp%20realistic%20sunny%20day%20clean%20minimalist&width=900&height=650&seq=lst-fass-001&orientation=landscape',
    imageAlt: 'Fassade & Außenwände Sanierung',
    subLeistungen: [
      'Wärmedämmverbundsystem (WDVS)',
      'Strukturputz & Glattputz Außen',
      'Klinker- & Natursteinverblendung',
      'Fassadenanstrich & Beschichtung',
      'Balkonsanierung & Abdichtung',
      'Fensterbänke & Abschlussprofile',
      'Gerüststellung & -koordination',
      'Kärcher-Fassadenreinigung',
    ],
    vorteile: [
      { icon: 'ri-leaf-line', title: 'Energieeinsparung', text: 'Bis zu 40% weniger Heizkosten durch professionelle Dämmung.' },
      { icon: 'ri-home-smile-line', title: 'Wertsteigerung', text: 'Moderne Fassaden erhöhen den Immobilienwert dauerhaft.' },
      { icon: 'ri-cloud-windy-line', title: 'Witterungsschutz', text: 'Langlebige Materialien, die Wind, Regen und Frost standhalten.' },
      { icon: 'ri-paint-line', title: 'Freie Gestaltung', text: 'Individuelles Farbkonzept und Oberflächenstruktur nach Wunsch.' },
    ],
  },
  {
    id: 'bodenbelaege',
    title: 'Bodenbeläge',
    shortDesc: 'Fachgerechte Verlegung von Fliesen, Parkett, Laminat und Estrich.',
    fullDesc:
      'Ein perfekter Boden trägt maßgeblich zur Wohnqualität und zum Raumgefühl bei. Wir verlegen alle gängigen Bodenbeläge fachgerecht und präzise – ob edles Massivparkett in Fischgrät, großformatige Feinsteinzeugfliesen oder langlebiger Designboden. Von der Untergrundvorbereitung über den Estricheinbau bis zur finalen Verlegung übernehmen wir die komplette Prozesskette.',
    icon: 'ri-grid-line',
    image:
      'https://readdy.ai/api/search-image?query=luxurious%20large%20format%20porcelain%20tile%20floor%20newly%20installed%20bright%20modern%20living%20room%20germany%20professional%20flooring%20renovation%20warm%20tones%20natural%20light%20beautiful%20craftsmanship%20clean%20minimal%20interior&width=900&height=650&seq=lst-boden-001&orientation=landscape',
    imageAlt: 'Bodenbeläge professionell verlegen',
    subLeistungen: [
      'Parkett & Dielen (Massiv, Mehrschicht)',
      'Fliesen & Feinsteinzeug',
      'Laminat & Vinylboden (LVT/SPC)',
      'Estrich (Zement, Anhydrit, Heizestrich)',
      'Teppich & Schlingenteppich',
      'Naturstein (Marmor, Granit, Travertin)',
      'Unterbodenausgleich & Abdichtung',
      'Sockelleisten & Übergangsprofil',
    ],
    vorteile: [
      { icon: 'ri-ruler-line', title: 'Maßgenaue Verlegung', text: 'Millimetergenaue Arbeit für fugenlose, optisch perfekte Ergebnisse.' },
      { icon: 'ri-recycle-line', title: 'Materialberatung', text: 'Wir helfen Ihnen beim optimalen Belag für jeden Raum.' },
      { icon: 'ri-drop-line', title: 'Feuchtigkeitsschutz', text: 'Fachgerechte Abdichtung vor der Verlegung schützt langfristig.' },
      { icon: 'ri-medal-line', title: 'Meisterbetrieb', text: 'Handwerksmeister-Qualität bei jedem Bodenbelag-Projekt.' },
    ],
  },
  {
    id: 'malerarbeiten',
    title: 'Malerarbeiten',
    shortDesc: 'Innen- und Außenanstriche, Tapezierarbeiten und dekorative Wandgestaltung.',
    fullDesc:
      'Der letzte Schliff entscheidet. Unsere Malerarbeiten zeichnen sich durch perfekte Vorbereitung, sorgfältige Ausführung und deckende, langlebige Qualität aus. Wir übernehmen klassische Innen- und Außenanstriche ebenso wie kreative Dekorputze, Tapezierarbeiten und Spachteltechniken. Wir arbeiten sauber, schützen alle angrenzenden Flächen zuverlässig und hinterlassen nach dem Auftrag keinerlei Schmutz.',
    icon: 'ri-paint-brush-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20interior%20painting%20work%20bright%20airy%20room%20freshly%20painted%20white%20walls%20clean%20roller%20brush%20technique%20germany%20residential%20renovation%20meticulous%20craftsmanship%20tidy%20workspace%20quality%20finish%20daylight&width=900&height=650&seq=lst-mal-001&orientation=landscape',
    imageAlt: 'Professionelle Malerarbeiten',
    subLeistungen: [
      'Innenanstrich (Wände & Decken)',
      'Außenanstrich & Fassadenfarbe',
      'Tapezierarbeiten (alle Tapetenarten)',
      'Dekorputze & Strukturputze',
      'Spachtel- & Glätttechnik',
      'Holzschutz & Lackierarbeiten',
      'Farbkonzept & Beratung',
      'Stucksanierung & Restaurierung',
    ],
    vorteile: [
      { icon: 'ri-drop-fill', title: 'Keine Flecken', text: 'Wir schützen Böden, Möbel und angrenzende Flächen zuverlässig.' },
      { icon: 'ri-eye-line', title: 'Farbberatung', text: 'Wir helfen Ihnen, das perfekte Farbkonzept zu finden.' },
      { icon: 'ri-brush-2-line', title: 'Saubere Kanten', text: 'Präzises Abkleben für messerscharfe Übergänge.' },
      { icon: 'ri-sun-line', title: 'Schnelle Trocknung', text: 'Hochwertige Farben trocknen schnell – minimale Beeinträchtigung.' },
    ],
  },
  {
    id: 'galabau',
    title: 'Garten- & Landschaftsbau',
    shortDesc: 'Von Pflasterarbeiten und Teichbau bis Rasenpflege und Bepflanzung.',
    fullDesc:
      'Ein schöner Außenbereich steigert die Lebensqualität und den Wert Ihrer Immobilie. Wir gestalten Gärten, Terrassen, Einfahrten und Grünflächen nach Ihren Wünschen – professionell, nachhaltig und langlebig. Von der Pflasterung einer Einfahrt über den Bau einer Teichanlage bis hin zur vollständigen Gartengestaltung mit Bepflanzung und Bewässerungsanlage bieten wir das komplette GalaBau-Spektrum.',
    icon: 'ri-plant-line',
    image:
      'https://readdy.ai/api/search-image?query=professionally%20designed%20beautiful%20residential%20garden%20outdoor%20space%20germany%20natural%20stone%20patio%20terrace%20ornamental%20pond%20water%20feature%20lush%20plants%20flowers%20green%20lawn%20elegant%20landscaping%20bright%20summer%20daylight%20wide%20angle&width=900&height=650&seq=lst-gala-001&orientation=landscape',
    imageAlt: 'Garten- und Landschaftsbau',
    subLeistungen: [
      'Pflasterarbeiten (Granit, Beton, Klinker)',
      'Teichbau & Wasserspiele',
      'Terrassenbau (Natur- & Kunststein)',
      'Rasenpflege & Rollrasen-Verlegung',
      'Beet- & Staudenpflanzung',
      'Heckenpflanzung & Gehölzschnitt',
      'Bewässerungsanlagen (automatisch)',
      'Entwässerungslösungen & Drainage',
    ],
    vorteile: [
      { icon: 'ri-seedling-line', title: 'Nachhaltige Bepflanzung', text: 'Standortgerechte Pflanzen, die dauerhaft gedeihen und wenig Pflege brauchen.' },
      { icon: 'ri-water-flash-line', title: 'Smarte Bewässerung', text: 'Automatische Bewässerungsanlagen sparen Zeit und Wasser.' },
      { icon: 'ri-landscape-line', title: 'Individuelle Planung', text: 'Jeder Garten ist einzigartig – wir planen individuell nach Ihren Wünschen.' },
      { icon: 'ri-building-2-line', title: 'Privat & Gewerbe', text: 'Erfahrung in Wohn- und Gewerbeobjekten jeder Größe.' },
    ],
  },
  {
    id: 'bauzeichnungen',
    title: 'Bauzeichnungen für Garten & Landschaften',
    shortDesc: 'Maßgenaue Planungs- und Ausführungszeichnungen von der Skizze bis zum Lageplan.',
    fullDesc:
      'Bevor der erste Spatenstich gesetzt wird, steht ein präziser Plan. Wir erstellen professionelle Bauzeichnungen und Lagepläne für Garten- und Landschaftsprojekte – vom Bestandsplan über die Entwurfsplanung bis zum detaillierten Ausführungsplan. Unsere Zeichnungen bilden die verlässliche Grundlage für Kostenplanung, Genehmigungsverfahren und die handwerkliche Umsetzung.',
    icon: 'ri-draft-line',
    image:
      'https://readdy.ai/api/search-image?query=professional%20landscape%20architect%20drawing%20technical%20blueprint%20plans%20on%20large%20drafting%20table%20with%20ruler%20compass%20pencil%20detailed%20garden%20layout%20overhead%20view%20bright%20studio%20white%20clean%20germany%20precise%20design%20planning&width=900&height=650&seq=lst-zeich-001&orientation=landscape',
    imageAlt: 'Bauzeichnungen für Garten und Landschaften',
    subLeistungen: [
      'Bestandsaufnahme & Vermessung',
      'Vorentwurf & Konzeptzeichnung',
      'Lageplan M 1:100 / 1:200',
      'Bepflanzungsplan mit Artenliste',
      'Entwässerungs- & Gefälleplanung',
      'Schnittzeichnungen & Details',
      'Leistungsverzeichnis (LV) erstellen',
      '3D-Visualisierung auf Anfrage',
    ],
    vorteile: [
      { icon: 'ri-file-list-3-line', title: 'Genehmigungsfähig', text: 'Unsere Pläne erfüllen alle Anforderungen für Baugenehmigungen.' },
      { icon: 'ri-money-euro-circle-line', title: 'Kostensicherheit', text: 'Detaillierte LVs ermöglichen genaue Angebote ohne Überraschungen.' },
      { icon: 'ri-eye-2-line', title: '3D-Visualisierung', text: 'Sehen Sie Ihr Projekt vor dem Bau – realistisch und detailgetreu.' },
      { icon: 'ri-links-line', title: 'Planung & Bau aus einer Hand', text: 'Von der Zeichnung bis zur Umsetzung – wir begleiten Sie durch.' },
    ],
  },
];
